import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'src/components/atoms/button';
import { Icon } from 'src/components/atoms/icon';
import { mapModifiers } from 'src/libs/component';

interface NotificationProps {
  children: React.ReactNode;
  hasNotification?: boolean;
  onOpen?: () => void;
}

export const Notification: React.FC<NotificationProps> = props => {
  const [isShow, setIsShow] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setIsShow(prev => {
      const next = !prev;
      if (next) props.onOpen?.();
      return next;
    });
  };

  useEffect(() => {
    const hanleClickOutside = (event: MouseEvent) => {
      if (!ref.current) return;
      const target = event.target as Node;
      if (!ref.current.contains(target)) {
        setIsShow(false);
      }
    };

    document.addEventListener('click', hanleClickOutside);

    return () => document.removeEventListener('click', hanleClickOutside);
  }, []);

  return (
    <div className={mapModifiers('m-notification', isShow && 'active')} ref={ref}>
      <Button modifiers="only-icon" onClick={handleToggle}>
        <Icon name="notification" />
        {props.hasNotification && <span className="m-notification__red-dot" />}
      </Button>
      {React.Children.count(props.children) > 0 && (
        <ul className="m-notification__items">
          {props.children}
        </ul>
      )}
    </div>
  );
};

interface NotificationItemProps {
  children: React.ReactNode;
  className?: string;
}

export const NotificationItem: React.FC<NotificationItemProps> = props => (
  <li className={props.className ? `m-notification__item ${props.className}` : 'm-notification__item'}>
    {props.children}
  </li>
);
